var React = require('react');
var Router = require('react-router');
var NotFoundRoute = Router.NotFoundRoute;
var Route = Router.Route;

var Access = require('./components/Access/Access');
var AccessInvite = require('./components/Access/AccessInvite');
var AccessNew = require('./components/Access/AccessNew');
var AccessNewPartner= require('./components/Access/AccessNewPartner');
var AccessManage = require('./components/Access/AccessManage');
var AccessPartner = require('./components/Access/AccessPartner');
var AccountingView = require('./components/Accounting/View');
var BillingGroupView = require('./components/BillingGroup/View');
var ClientServiceList = require('./components/ClientService/List');
var Upgrade = require('./components/ClientService/Upgrade');
var ClientServiceView = require('./components/ClientService/View');
var CpanelRedirect = require('./components/ClientService/CpanelRedirect');
var Dashboard = require('./components/Dashboard/Dashboard');
var Login = require('./components/Authentication/Login');
var LoginError = require('./components/Authentication/Error');
var LoginTimeout = require('./components/Authentication/Timeout');
var Logout = require('./components/Authentication/Logout');
var NotFound = require('./components/Layout/NotFound');
var Partner = require('./components/Partner/Portal');
var PartnerDashboard = require('./components/Partner/Dashboard');
var PartnerService = require('./components/Partner/Service');
var Payment = require('./components/Accounting/Payment');
var PaymentMethodsView = require('./components/Accounting/PaymentMethodsView');
var Portal = require('./components/Portal');
var Settings = require('./components/Settings/Settings');
var SignupWelcomeHandler = require('./components/Signup/WelcomeHandler');
var Support = require('./components/Support/Support');

var routes = [
    <Route handler={Portal()}>
        <Route name="dashboard" path="/" handler={Dashboard} />
        <Route name="accounting" path="/accounting" handler={AccountingView} />
        <Route name="payment-methods" path="/accounting/payment-methods" handler={PaymentMethodsView} />
        <Route name="billing-group" path="/accounting/:billingGroupId" handler={BillingGroupView} />
        <Route name="access" path="/access" handler={Access} />
        <Route name="access-new" path="/access/new" handler={AccessNew} />
        <Route name="access-manage" path="/access/manage/:id" handler={AccessManage} />
        <Route name="access-manage-invite" path="/access/manage-invite/:id" handler={AccessInvite} />
        <Route name="access-manage-partner" path="/access/manage-partner/:id" handler={AccessPartner} />
        <Route name="auth" path="/auth" handler={AccessNewPartner} />
        <Route handler={Partner}>
          <Route name="partner" path="/partner" handler={PartnerDashboard} />
          <Route name="partner-service" path="/partner/:clientId/:serviceId" handler={PartnerService} />
        </Route>
        <Route name="payment" path="/payment" handler={Payment} />
        <Route name="services" path="/service" handler={ClientServiceList} />
        <Route name="service" path="/service/:serviceId" handler={ClientServiceView} />
        <Route name="service-upgrade" path="/service/:serviceId/upgrade" handler={Upgrade} />
        <Route name="settings" path="/settings" handler={Settings} />
        <Route name="support" path="/support" handler={Support} />
    </Route>,
    <Route handler={Portal({authenticated:false})}>
        <Route name="signup-welcome" path="/signup" handler={SignupWelcomeHandler} />
    </Route>,
    <Route name="cpanel-redirect" path="/service/:serviceId/cpanel" handler={CpanelRedirect} />,
    <Route name="logout" path="/logout" handler={Logout} />,
    <Route name="login-error" path="/login/error" handler={LoginError} />,
    <Route name="login-timeout" path="/login/timeout" handler={LoginTimeout} />,
    <Route name="login" path="/login" handler={Login} />,
    <NotFoundRoute name="not-found" handler={NotFound} />
];

var router = Router.create({
    routes: routes,
    location: Router.HistoryLocation
});

module.exports = router;



// WEBPACK FOOTER //
// ./app/router.js